import React from 'react'

import { Informacoes } from './Informacoes'
import { Services } from './Services'

export function TabSelect({ tab }) {
  switch (tab) {
    case 'informacoes':
      return <Informacoes />
    case 'services':
      return <Services />
    default:
      return <Informacoes />
  }
}
